import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { POI, PoiComponent } from '../poi/poi.component';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'cue-pois',
  imports: [PoiComponent, TranslocoPipe],
  templateUrl: './pois.component.html',
  styleUrl: './pois.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoisComponent {
  selectedQrCodeId = input<string>();
  pois = input<POI[]>();
  links = input<boolean, boolean | string>(true, {
    transform: booleanAttribute,
  });
  poiClicked = output<POI>();

  protected readonly translation = translation;
}
